/* eslint-disable react/no-multi-comp */
import React from 'react'
import { type DashTableColumns } from 'legacy/dash-blocks/dash-table/utils/dashTable.types'
import { DashTableTextCell } from 'legacy/dash-blocks/dash-table-text-cell/DashTableTextCell'
import { dashPixels } from 'legacy/dash-blocks/foundation/spacing-units/spacingUnits.types'
import { OrdersListTableChargeCell } from 'legacy/sections/orders/components/list/components/table/components/OrdersListTableChargeCell'
import { toFloat } from 'utils/parsing/numbers'
import { OrdersListTableCreatedAtCell } from 'legacy/sections/orders/components/list/components/table/components/OrdersListTableCreatedAtCell'
import { type OrderType } from 'legacy/sections/orders/utils/orders.types'
import { OrdersListTableOrderCell } from 'legacy/sections/orders/components/list/components/table/components/OrdersListTableOrderCell'
import { OrderListTableStatusCell } from 'legacy/sections/orders/components/list/components/table/components/OrdersListTableStatusCell'
import { OrdersListTableEtaCell } from 'legacy/sections/orders/components/list/components/table/components/eta-cell/OrdersListTableEtaCell'
import { type OrdersListApiOrder } from 'legacy/sections/orders/components/list/utils/ordersList.types'

interface MakeOrdersListTableColumnProps {
  orderType: OrderType
  showDeliveryOptionColumn: boolean
}

export const makeOrdersListTableColumns = ({
  orderType,
  showDeliveryOptionColumn,
}: MakeOrdersListTableColumnProps): DashTableColumns<OrdersListApiOrder> => [
  {
    id: 'order-id',
    Header: 'Order ID',
    width: 150,
    Cell: ({
      row: {
        original: { id, order_id },
      },
    }) => <OrdersListTableOrderCell orderId={order_id} orderDeliveryId={id} />,
    paddingLeft: dashPixels.PX8,
  },
  {
    id: 'name',
    Header: 'Name',
    width: 110,
    Cell: ({
      row: {
        original: { user_name },
      },
    }) => <DashTableTextCell>{user_name}</DashTableTextCell>,
  },
  {
    id: 'eta',
    Header: 'ETA',
    width: 100,
    Cell: ({
      row: {
        original: { eta, delivery_option },
      },
    }) => (
      <OrdersListTableEtaCell eta={eta} deliveryOption={delivery_option} orderType={orderType} />
    ),
  },
  {
    id: 'created-time',
    Header: 'Created',
    width: 100,
    Cell: ({
      row: {
        original: { created_at },
      },
    }) => <OrdersListTableCreatedAtCell format="time" createdAt={created_at} />,
  },
  {
    id: 'created-date',
    Header: 'Date',
    width: 70,
    Cell: ({
      row: {
        original: { created_at },
      },
    }) => <OrdersListTableCreatedAtCell format="date" createdAt={created_at} />,
  },
  {
    id: 'store-name',
    Header: 'Store',
    minWidth: 160,
    Cell: ({
      row: {
        original: { store_name },
      },
    }) => <DashTableTextCell>{store_name}</DashTableTextCell>,
  },
  {
    id: 'items-total',
    Header: 'Items Total',
    width: 140,
    Cell: ({
      row: {
        original: { items_total },
      },
    }) => <OrdersListTableChargeCell charge={toFloat(items_total)} />,
  },
  {
    id: 'delivery-fee',
    Header: 'Delivery Fee',
    width: 120,
    Cell: ({
      row: {
        original: { shipping_price },
      },
    }) => <OrdersListTableChargeCell charge={toFloat(shipping_price)} />,
  },
  {
    id: 'delivery-option',
    Header: 'Delivery Option',
    width: 120,
    Cell: ({
      row: {
        original: { delivery_option },
      },
    }) => <DashTableTextCell>{delivery_option}</DashTableTextCell>,
    isVisible: showDeliveryOptionColumn,
  },
  {
    id: 'delivery-status',
    Header: 'Status',
    width: 130,
    Cell: ({
      row: {
        original: { status: orderStatus, picking_percentage, alcoholic },
      },
    }) => (
      <OrderListTableStatusCell
        status={orderStatus}
        percent={picking_percentage}
        alcoholic={alcoholic}
      />
    ),
  },
]
